import { Icon } from "./Icon";

interface MusicChoiceProps {
  playLabel?: string;
  skipLabel?: string;
  playIcon?: string;
  skipIcon?: string;
  onPlayWithMusic: () => void;
  onContinueWithout: () => void;
}

/**
 * MusicChoice - renders two buttons so the viewer can choose to play
 * with background music or continue without it. Both choices advance the narrative.
 */
export function MusicChoice({
  playLabel = "Play with Music",
  skipLabel = "Continue without",
  playIcon,
  skipIcon,
  onPlayWithMusic,
  onContinueWithout,
}: MusicChoiceProps) {
  // undefined = use default icon, empty string = no icon. Icon renders nothing
  // for empty/undefined input, so the empty-string case needs no extra guard.
  const resolvedPlayIcon = playIcon === undefined ? "fausb music" : playIcon;

  return (
    <div className="flex flex-col gap-3 w-full max-w-xs mx-auto">
      <button
        onClick={onPlayWithMusic}
        className="flex items-center justify-center gap-2 px-6 py-3 rounded-full font-medium shadow-lg cursor-pointer backdrop-blur-md border bg-white/20 hover:bg-white/30 text-white border-white/30 transition-all duration-200 hover:scale-105"
      >
        <Icon icon={resolvedPlayIcon} />
        {playLabel}
      </button>
      <button
        onClick={onContinueWithout}
        className="flex items-center justify-center gap-2 px-6 py-3 rounded-full font-medium cursor-pointer border bg-transparent hover:bg-white/10 text-white/70 hover:text-white border-white/20 transition-all duration-200"
      >
        <Icon icon={skipIcon} />
        {skipLabel}
      </button>
    </div>
  );
}
